// @flow

import type { State } from "@store/reducers";
import type { DefaultStandardScript } from "@modules/service/reducer/default-standard-scripts/types";

export const getDefaultStandardScriptsList = (state: State): ?Array<DefaultStandardScript> =>
  (state.service.defaultStandardScripts.list || {}).content || [];

export const currentDefaultStandardScriptContainer = (state: State): ?DefaultStandardScript =>
  state.service.defaultStandardScripts.current;

export const getDefaultStandardScriptDraft = (state: State): ?DefaultStandardScript =>
  state.service.defaultStandardScripts.draft;

// MODALS
export const getShowDefaultStandardScriptEditModal = (state: State): boolean =>
  state.service.defaultStandardScripts.modals.showEditModal;
